import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClockList20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconClockList20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 10a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M8 3a7 7 0 1 0 0 14A7 7 0 0 0 8 3m.75 3.75a.75.75 0 0 0-1.5 0v3.75H10A.75.75 0 0 0 10 9H8.75zM17.25 9h-1.312a8 8 0 0 0-.336-1.5h1.648a.75.75 0 0 1 0 1.5m0-3.5h-2.635A8 8 0 0 0 13.292 4h3.958a.75.75 0 0 1 0 1.5M15.938 11a8 8 0 0 1-.336 1.5h1.648a.75.75 0 0 0 0-1.5zm-1.323 3.5a8 8 0 0 1-1.323 1.5h3.958a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClockList20);
